import { useQuery } from '@tanstack/react-query';
// import isEmpty from 'lodash/isEmpty';
import isString from 'lodash/isString';
import queryString from 'query-string';
import { useIntl } from 'react-intl';

import { useApi } from '../contexts/ApiContext';

const useTanQuery = (group, url, { query = null, page = null, count = null, ...config } = {}) => {
    const api = useApi();
    const { locale } = useIntl();
    const key = [group || 'group', isString(url) ? url : 'callback', query, page, count];

    const {
        data = null,
        status = null,
        isLoading = false,
        isError = false,
        isFetching = false,
        refetch = null,
        ...otherProps
    } = useQuery({
        queryKey: key,
        queryFn: ({ queryKey: [, , queryParams, pageParam, countParam] }) => {
            if (typeof url === 'function') {
                return url(queryParams, pageParam, countParam);
            }
            if (isString(url)) {
                const finalParams = { ...queryParams, page: pageParam, count: countParam };
                return api.requestGet(
                    `${url}${`?${queryString.stringify(finalParams, { arrayFormat: 'bracket' })}`}`,
                    null,
                    { withCredentials: true, withLocale: true, locale },
                );
            }
            return null;
        },
        suspense: false,
        retry: 1,
        refetchOnMount: 'always',
        ...config,
    });

    return {
        ...otherProps,
        data,
        isLoading,
        isError,
        status,
        loading: !isError && (isFetching || isLoading),
        refetch,
    };
};

export default useTanQuery;
